/**
 * Template registry for inbasket
 * Manages template loading and provides helper functions
 */

import { TemplateInbasketEnum } from "../../../../convex/schema";
import { defaultTemplate } from "./default";
import { rapideTemplate } from "./rapide";
import type { InbasketTemplateConfig } from "./types";

// Registry of all available templates
const templateRegistry: Record<string, InbasketTemplateConfig> = {
  [TemplateInbasketEnum.DEFAULT]: defaultTemplate,
  [TemplateInbasketEnum.RAPIDE]: rapideTemplate,
  // Add future templates here:
  // [TemplateInbasketEnum.TEMPLATE_A]: templateA,
};

/**
 * Get template configuration by ID
 * Falls back to default if template not found
 */
export function getTemplate(templateId?: string): InbasketTemplateConfig {
  if (!templateId || !templateRegistry[templateId]) {
    return defaultTemplate;
  }
  return templateRegistry[templateId];
}

/**
 * Get all available template IDs
 */
export function getAvailableTemplateIds(): string[] {
  return Object.keys(templateRegistry);
}

/**
 * Check if a template exists
 */
export function templateExists(templateId: string): boolean {
  return templateId in templateRegistry;
}

// Re-export types and default template
export { defaultTemplate } from "./default";
export { rapideTemplate } from "./rapide";
export type { InbasketTemplateConfig } from "./types";

